import { Helmet, HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import ScrollToTop from "../src/utils/ScrollToTop";
import LoginPage from "./arcView/components/login/LoginPage";
import { AccountingPage } from "./arcView/containers/admin/AccountingPage";
import ContentControl from "./arcView/containers/admin/ContentControl";
import CustomProductControl from "./arcView/containers/admin/CustomProductControl";
import ProductControl from "./arcView/containers/admin/ProductControl";
import ProductControlAEB from "./arcView/containers/admin/ProductControlAEB";
import ProductManufacturer from "./arcView/containers/admin/ProductManufacturer";
import SocialMediaControl from "./arcView/containers/admin/SocialMediaControl";
import NotFoundPage from "./arcView/containers/notFound/NotFoundPage";
import OrderHistoryPage from "./arcView/containers/otto/OrderHistoryPage/OrderHistoryPage";
import OrderPackPage from "./arcView/containers/otto/OrderPackPage/OrderPackPage";
import OrderPickPage from "./arcView/containers/otto/OrderPickPage/OrderPickPage";
import OrderPickUpPage from "./arcView/containers/otto/OrderPickUpPage/OrderPickUpPage";
import RetourenPage from "./arcView/containers/otto/RetourenPage/RetourenPage";
import OrderTable from "./arcView/containers/webshop/OrderTable";
import OrderTableOverview from "./arcView/containers/webshop/OrderTableOverview";
import OrderTablePacked from "./arcView/containers/webshop/OrderTablePacked";
import OrderTablePicked from "./arcView/containers/webshop/OrderTablePicked";
import OrderTableReturned from "./arcView/containers/webshop/OrderTableReturned";
import { InvoiceProvider } from "./arcView/helper/AccountingContext";
import { AnalyticsProvider } from "./arcView/helper/AnalyticsContext";
import { AnalyticsWebshopProvider } from "./arcView/helper/AnalyticsWebshopContext";
import { AuthProvider } from "./arcView/helper/AuthContext";
import { ContentProvider } from "./arcView/helper/ContentContext";
import { CustomProductProvider } from "./arcView/helper/CustomProductContext";
import { LinkListProvider } from "./arcView/helper/LinkHelper";
import { OrderProvider } from "./arcView/helper/OrderContext";
import { OrderWebshopProvider } from "./arcView/helper/OrderWebshopContext";
import { ProductProvider } from "./arcView/helper/ProductContext";
import { ProductProviderAEB } from "./arcView/helper/ProductContextAEB";
import AdminLayout from "./arcView/layout/AdminLayout";
import CmsAdminPanel from "./arcView/containers/cms/CmsComponent";
import { CmsProvider } from "./arcView/containers/cms/CmsProvider";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageTitleHelmet />
      <AuthProvider>
        <OrderProvider>
          <OrderWebshopProvider>
            <CustomProductProvider>
              <ProductProvider>
                <ProductProviderAEB>
                  <ContentProvider>
                    <AnalyticsProvider>
                      <AnalyticsWebshopProvider>
                        <InvoiceProvider>
                          <LinkListProvider>
                            <CmsProvider>
                              <Routes>
                                <Route path="/" element={<AdminLayout />}>
                                  <Route path="otto/picken" element={<OrderPickPage />} />
                                  <Route path="otto/packen" element={<OrderPackPage />} />
                                  <Route path="otto/verpacken" element={<OrderPickUpPage />} />
                                  <Route path="otto/historie" element={<OrderHistoryPage />} />
                                  <Route path="otto/retouren" element={<RetourenPage />} />
                                  <Route path="webshop/eingang" element={<OrderTable />} />
                                  <Route path="webshop/gepickt" element={<OrderTablePicked />} />
                                  <Route path="webshop/verpackt" element={<OrderTablePacked />} />
                                  <Route path="webshop/retouren" element={<OrderTableReturned />} />
                                  <Route path="webshop/historie" element={<OrderTableOverview />} />
                                  <Route path="admin/product-control" element={<ProductControl />} />
                                  <Route path="admin/custom-content-control" element={<ContentControl />} />
                                  <Route path="admin/product" element={<ProductControlAEB />} />
                                  <Route path="admin/product/manufacturer" element={<ProductManufacturer />} />
                                  <Route path="admin/accounting" element={<AccountingPage />} />
                                  <Route path="admin/cms" element={<CmsAdminPanel company="FUFOLI" />} />
                                  <Route path="admin/social/links" element={<SocialMediaControl />} />
                                  <Route path="admin/custom-product-control" element={<CustomProductControl />} />
                                </Route>
                                <Route path="login" element={<LoginPage />} />
                                <Route path="*" element={<NotFoundPage />} />
                              </Routes>
                            </CmsProvider>
                          </LinkListProvider>
                        </InvoiceProvider>
                      </AnalyticsWebshopProvider>
                    </AnalyticsProvider>
                  </ContentProvider>
                </ProductProviderAEB>
              </ProductProvider>
            </CustomProductProvider>
          </OrderWebshopProvider>
        </OrderProvider>
      </AuthProvider>
    </Router>
  );
}

function PageTitleHelmet() {
  const location = useLocation();

  const pageTitle =
    {
      "/dashboard": "ArcView",
      "/login": "ArcView | Login",
    }[location.pathname] || "ArcView";

  return (
    <HelmetProvider>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
    </HelmetProvider>
  );
}

export default App;
